import { registerDe } from '../i18n/index.js';

registerDe({
  'Dossier': 'Dossier',
  'No dossier yet. Research runs nightly for tier A, weekly for tier B, or now. A dossier is a document, not a fact: it keeps its ◇ mark for ever, and no verb turns one of its sentences into a fact. Each [n] expands to the verbatim quote and the snapshot it was read from.': 'Noch kein Dossier. Die Recherche läuft nachts für Stufe A, wöchentlich für Stufe B, oder jetzt. Ein Dossier ist ein Dokument, keine Tatsache: Es behält sein ◇ für immer, und kein Verb macht aus einem seiner Sätze einen Fakt. Jedes [n] öffnet das wörtliche Zitat und den Snapshot, aus dem es gelesen wurde.',
  'a document with its receipts, never a fact': 'ein Dokument mit seinen Belegen, nie ein Fakt',
  'written by an agent; a dossier is never held': 'von einem Agenten geschrieben; ein Dossier wird nie übernommen',
  'written by': 'geschrieben von',
  '{n} version': '{n} Version',
  '{n} versions': '{n} Versionen',
  'Previous versions': 'Frühere Versionen',
  'Hide versions': 'Versionen ausblenden',
  'Versions': 'Versionen',
  'The versions could not be listed.': 'Die Versionen konnten nicht aufgelistet werden.',
  'Showing version {v}; the latest is version {latest}.': 'Version {v} wird gezeigt; die neueste ist Version {latest}.',
  'Back to the latest': 'Zurück zur neuesten',
  'shown': 'angezeigt',
  'Show': 'Anzeigen',
  'Untitled dossier': 'Dossier ohne Titel',
  'show the quote behind [{n}]': 'das Zitat hinter [{n}] zeigen',
  'this citation is not in the list': 'diese Belegstelle steht nicht in der Liste',
  'fetch date not recorded': 'Abrufdatum nicht erfasst',
  '{n} source': '{n} Quelle',
  '{n} sources': '{n} Quellen',
  'Hide sources': 'Quellen ausblenden',
  'The dossier could not be read: {error}': 'Das Dossier konnte nicht gelesen werden: {error}',
}, 'DossierZone');
